import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
// import Typography from '@material-ui/core/Typography';
// import { Text } from 'recharts';
import Button from '@material-ui/core/Button';
import renderHTML from 'react-render-html';
import {
  getGroupIdentities,
  editIdentityGroupStatus
} from '../../actions/Identity';
import { sendLogin } from '../../auth/Auth';

const styles = {
  root: {
    position: 'absolute',
    width: '95%',
    maxWidth: '355px',
    height: 'auto',
    maxHeight: '80%',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    backgroundColor: '#fff',
    padding: 15,
    overflow: 'auto',
    outline: 'none',
    fontSize: 12,
    lineHeight: '16px',
    color: '#333333',
    borderRadius: 4
  },
  btnCloseDiv: {
    textAlign: 'center',
    marginTop: 20
  },
  btnClose: {
    fontSize: 14,
    fontWeight: 'bold',
    width: '100%',
    marginBottom: 10
  },
  pubDate: {
    fontWeight: 'bold',
    marginTop: 5,
    textAlign: 'left'
  },
  titleDetail: {
    marginBottom: 20,
    lineHeight: 'normal'
  },
  content: {
    overflowWrap: 'break-word',
    lineHeight: 'normal'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getGroupIdentities, editIdentityGroupStatus },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openApprovalProgress', 'updateOpenApprovalProgress', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(({ classes, setDetailPost, params }) => {
  const closeAction = () => {
    setDetailPost(false);
  };

  return (
    <div className={classes.root}>
      <div className={classes.pubDate}>{params && params.pubDate}</div>
      <h1 className={classes.titleDetail}>{params && params.title}</h1>
      <div className={classes.content}>
        {params && renderHTML(params.content)}
      </div>

      <div className={classes.btnCloseDiv}>
        <Button
          color="primary"
          variant="contained"
          onClick={closeAction}
          className={classes.btnClose}
        >
          閉じる
        </Button>
      </div>
    </div>
  );
});

export default withRouter(withStyles(styles)(Main));
